import { Component, OnInit, Input, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Option } from '../../../../../classes';
import { NgModel, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  template: '',
})
export class OptionComponent implements OnInit {
  @ViewChild('text') text:NgModel
  @Input() option:Option;
  @Input() optionsFormGroup:FormGroup;
  constructor(
    protected cdRef:ChangeDetectorRef,
  ) {
  }

  subscriptions:Subscription[] = [];
  optionFormGroup:FormGroup;
  optionId:string;

  ngOnInit () { 
    this.createFormGroup();
    this.subscriptions.push(this.option.onContentUpdate.subscribe(()=>{
      this.refreshView();
    }));
  }  
  refreshView () {
    this.cdRef.detectChanges()

  }
  ngOnDestroy () {
    this.destroyFormGroup();
    this.subscriptions.forEach(sub=>sub.unsubscribe());
  }
  private createFormGroup () {
    if (this.optionsFormGroup) {
      this.optionId = this.option.id;
      this.optionFormGroup = new FormGroup({text:this.text.control});
      this.optionsFormGroup.setControl(this.optionId, this.optionFormGroup);
    }
  }
  private destroyFormGroup () {
    if (this.optionsFormGroup) {
      this.optionsFormGroup.removeControl(this.optionId);
    }  
  }


  delete () {
    this.option.question.deleteOptions({id:this.option.id});
  }
}
